module.exports = __webpack_public_path__ + "media/images/athletes/1086-f567071092b9536fa411053f0063da2f.png";